export const APPROVAL_STATUS = {
  NO_ACTION: 'NO_ACTION',
  DECLINED: 'DECLINED',
  APPROVED: 'APPROVED',
};
